import tw from "tailwind-styled-components"


export const NavContainer = tw.div `
flex 
justify-between
pb-4
lg:border-b 
border-gray 
w-[90%]
md:w-full
mt-2
lg:mt-4 
h-fit
items-center
`